import produce from "immer";
import { store } from "../../..";

export const TypesNavigationBar = {
	MINIMIZE: "mxApp/MINIMIZE",
	RESETNAVIGATIONBAR: "RESETNAVIGATIONBAR",
	CLOSE: "CLOSE",
	REMOVE_MINIMIZE: "mxApp/REMOVE_MINIMIZE",
	ON_GO_BACK: "mxApp/ON_GO_BACK",
	POP_ON_GO_BACK: "mxApp/POP_ON_GO_BACK",
	ON_MINIMIZAR: "mxApp/ON_MINIMIZAR",
	ON_VOLTAR_HOME: "mxApp/ON_VOLTAR_HOME",
	ON_TENTAR_SAIR: "mxApp/ON_TENTAR_SAIR",
	ATUALIZAR_NOME_DOS_APLICATIVOS_MX:
		"mxApp/ATUALIZAR_NOME_DOS_APLICATIVOS_MX",
	ATUALIZAR_NOME_APP_ATUAL: "mxApp/ATUALIZAR_NOME_APP_ATUAL",
};

const INITIAL = {
	NomeRotasAplicativosMarimex: [],
	Aplicativos: [],
	onMinimizar: false, //{cb}
	onVoltarHome: false, // {cb}
	onGoBack: false, // {cb}
	onTentarSair: false, // {cb}
	minimizadosOnGoBack: {},
	nomeAppAtual: "",
};

export default function MxNavigationBarReducer(state = INITIAL, action) {
	switch (action.type) {
		case TypesNavigationBar.MINIMIZE:
			return produce(state, (draft) => {
				const minimizadosOnGoBack = {};
				minimizadosOnGoBack[action.payload.Rota] = draft.onGoBack;
				return {
					...draft,
					Aplicativos: [...action.payload],
					minimizadosOnGoBack: {
						...draft.minimizadosOnGoBack,
						...minimizadosOnGoBack,
					},
				};
			});

		case TypesNavigationBar.REMOVE_MINIMIZE:
			return {
				Aplicativos: action.payload,
			};
		case TypesNavigationBar.CLOSE:
			return {
				...state,
				Aplicativos: [
					...state.Aplicativos.filter(function (a) {
						return !action.payload.includes(a.Rota);
					}),
				],
			};
		case TypesNavigationBar.RESETNAVIGATIONBAR:
			return INITIAL;
		//return { Aplicativos: [] };
		case TypesNavigationBar.ON_GO_BACK:
			return {
				...state,
				onGoBack: action.payload,
			};
		case TypesNavigationBar.POP_ON_GO_BACK:
			return {
				...state,
				onGoBack: state.minimizadosOnGoBack.get(action.payload),
				minimizadosOnGoBack: state.minimizadosOnGoBack.delete(
					action.payload.Rota
				),
			};
		case TypesNavigationBar.ON_MINIMIZAR:
			return {
				...state,
				onMinimizar: action.payload,
			};
		case TypesNavigationBar.ON_VOLTAR_HOME:
			return {
				...state,
				onVoltarHome: action.payload,
			};
		case TypesNavigationBar.ON_TENTAR_SAIR:
			return {
				...state,
				onTentarSair: action.payload,
			};
		case TypesNavigationBar.ATUALIZAR_NOME_APP_ATUAL:
			return {
				...state,
				nomeAppAtual: action.payload,
			};
		case TypesNavigationBar.ATUALIZAR_NOME_DOS_APLICATIVOS_MX:
			return {
				...state,
				NomeRotasAplicativosMarimex: action.payload,
			};
		default:
			return state;
	}
}

export const MxNavigationBarActions = {
	atualizarNomeDosAplicativosMarimex,
	minimize,
	remove_minimize,
	resetNavigationBarState,
	onGoBack,
	onVoltarHome,
	resetOnGoBack,
	desminimizarOnGoBack,
	onMinimizar,
	resetOnMinimizar,
	resetOnVoltarHome,
	onTentarSair,
	resetOnTentarSair,
};

/**
 *
 * @param {string[]} NomeRotasAplicativosMarimex
 * @returns
 */
function atualizarNomeDosAplicativosMarimex(NomeRotasAplicativosMarimex) {
	return {
		type: TypesNavigationBar.ATUALIZAR_NOME_DOS_APLICATIVOS_MX,
		payload: NomeRotasAplicativosMarimex,
	};
}

function minimize(appsMinimized) {
	return {
		type: TypesNavigationBar.MINIMIZE,
		payload: appsMinimized,
	};
}

function remove_minimize(rotaAtual, rotas) {
	let grupoCarrDesc = [
		"CarregaDescarregaContainer",
		"/CarregaDescarregaContainer/ListaGate",
		"/CarregaDescarregaContainer/vistoria",
		"/CarregaDescarregaContainer/EscolhePickup",
		"/CarregaDescarregaContainer/InterromperOperacao",
		"/CarregaDescarregaContainer/DetalheCarregaGate",
		"/remocao/",
		"/remocao/posicionarcontainer",
		"/remocao/escolhepickup",
		"/CarregaDescarregaContainer/AutorizarEntrada",
		"CarregaDescarregaVolumeMercadoria",
		"/CarregaDescarregaVolumeMercadoria/ListaOperacoes",
		"/CarregaDescarregaVolumeMercadoria/DetalheOperacao",
		"/CarregaDescarregaVolumeMercadoria/AutorizarEntrada",
		"/CarregaDescarregaVolumeMercadoria/Carregamento",
		"/CarregaDescarregaVolumeMercadoria/Carregamento/Detalhe",
		"/CarregaDescarregaVolumeMercadoria/Carregamento/Carregar",
		"/CarregaDescarregaVolumeMercadoria/Descarga",
		"/CarregaDescarregaVolumeMercadoria/Descarga/Detalhe",
		"/CarregaDescarregaVolumeMercadoria/Descarga/Descarregar",
		"/CarregaDescarregaVolumeMercadoria/InterromperOperacao"
	];
	let grupoReefer = ["/Reefer/ConsultaContainer", "/Reefer/RegistrarLeitura"];
	let grupoTurno = ["/HabilitaTurno"];
	let grupoConsultasGerais = ["Consultas Gerais", "Consultas Gerais Mobile"];
	let grupoSolServEstufagem = ["/SolServ", "/SolServItensEstufagem", "/VolumeEstufagem", "/InterromperEstufagem", "/FinalizarSolServEstufagem", "/FinalizarSolServEstufagemPeacao"];
	let grupoDesova = ["/ColetorDesova", "/ColetorDesova/IniciarDesova", "/ColetorDesova/InterromperDesova", "/ColetorDesova/Desovando", "/ColetorDesova/Desovar", "/ColetorDesova/AvariasVolume", "/ColetorDesova/AvariasContainer", "/ColetorDesova/DetalhesVolume", "/ColetorDesova/InformacoesSiscomex", "/ColetorDesova/FinalizarDesova", "/ColetorDesova/Acrescimo", "/ColetorDesova/Peacao"];
	let grupoSolServDesova = ["/SolServDesova", "/SolServDesova/DetalhesContainer", "/SolServDesova/IniciarDesova", "/SolServDesova/InterromperDesova", "/SolServDesova/DesovarVolume", "/SolServDesova/AvariasVolume", "/SolServDesova/ReconhecimentoVolume", "/SolServDesova/ReconhecerVolume", "/SolServDesova/FinalizarDesova", "/SolServDesova/AvariasContainer"];
	let grupoRemocaoVolumes = ["/RemocaoVolume"];
	let grupoEdicaoVolumes = ["/EdicaoVolumes"];
	let grupoImagensApp = ["/ImagensApp",
        "/Confere",
        "/Consulta",
        "/ConfirmaImagem",
        "/ImagensEmGeral",
    ];


	let appsMinimized = rotas.Aplicativos;
	let arrMinimized = appsMinimized.filter(function (e) {
		return e.Rota !== rotaAtual;
	});

	if (grupoCarrDesc.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoCarrDesc.includes(e.Rota);
		});
	}

	if (grupoReefer.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoReefer.includes(e.Rota);
		});
	}

	if (grupoTurno.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoTurno.includes(e.Rota);
		});
	}

	if (grupoConsultasGerais.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoConsultasGerais.includes(e.Rota);
		});
	}

	if (grupoSolServEstufagem.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoSolServEstufagem.includes(e.Rota);
		});
	}

	if (grupoDesova.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoDesova.includes(e.Rota);
		});
	}

	if (grupoSolServDesova.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoSolServDesova.includes(e.Rota);
		});
	}
	
	if (grupoRemocaoVolumes.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoRemocaoVolumes.includes(e.Rota);
		});
	}
	
	if (grupoEdicaoVolumes.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoEdicaoVolumes.includes(e.Rota);
		});
	}

	if (grupoImagensApp.includes(rotaAtual)) {
		arrMinimized = appsMinimized.filter(function (e) {
			return !grupoImagensApp.includes(e.Rota);
		});
	}

	return {
		type: TypesNavigationBar.REMOVE_MINIMIZE,
		payload: arrMinimized,
	};
}

function resetNavigationBarState() {
	return { type: "RESETNAVIGATIONBAR" };
}
/**
 * Callback executado ao clicar no botão de voltar da NavigationBar. Default: history.goBack()
 *
 * @param {() => void} callback
 * @param {{limparAposUso: boolean}} options Limpa o callback após a execução
 * @default options.limparAposUso = true
 */
function onGoBack(callback, options = { limparAposUso: false }) {
	return {
		type: TypesNavigationBar.ON_GO_BACK,
		payload: () => {
			if (options.limparAposUso) store.dispatch(resetOnGoBack());
			callback();
		},
	};
}
/**
 * Reseta o cb da função onGoBack
 *
 */
function resetOnGoBack() {
	return {
		type: TypesNavigationBar.ON_GO_BACK,
		payload: INITIAL.onGoBack,
	};
}

/**
 * Executada quando o app é desminimizado.
 * Acha o app que foi minimizado na MinimizadosOnGoBack e atualiza o onGoBack com ele
 * @param {*} app
 *
 */

function desminimizarOnGoBack(app) {
	return {
		type: TypesNavigationBar.POP_ON_GO_BACK,
		payload: app,
	};
}

/**
 * Callback chamado quando o usuário volta para a tela inicial pelo botão de "minimizar" e clicando na opção "Não".
 * É preciso passar uma função de resetar que o resete o estado do app. Se não for passada, o app usará a versão legada que se baseia no nome das rotas para resetar.
 * Necessário caso esteja usando o redux.
 * @param {() => void} callback Função de resetar o estado da aplicação
 * @required
 */
function onVoltarHome(callback) {
	return {
		type: TypesNavigationBar.ON_VOLTAR_HOME,
		payload: () => {
			store.dispatch(resetOnVoltarHome());
			return callback();
		},
	};
}

/**
 * Reseta o cb da função onVoltarHome
 */

function resetOnVoltarHome() {
	return {
		type: TypesNavigationBar.ON_VOLTAR_HOME,
		payload: INITIAL.onVoltarHome,
	};
}

/**
 * Callback executado ao minimizar o aplicativo após clicar no botão home da NavBar e confirmar a ação.
 * @typedef {Object} OnMinimizarOptions
 * @property {boolean | (() => void)} [preventDefault=false] Previne a ação de minimizar o app. Se for uma função, ela será executada no lugar da ação de voltar home.
 *
 * 	@param {() => OnMinimizarOptions | void}  callback Função chamada ao minimizar o app
 */
function onMinimizar(callback) {
	return {
		type: TypesNavigationBar.ON_MINIMIZAR,
		payload: () => {
			store.dispatch(resetOnMinimizar());
			return callback();
		},
	};
}
/**
 * Reseta o cb da função onMinimizar
 */
function resetOnMinimizar() {
	return {
		type: TypesNavigationBar.ON_MINIMIZAR,
		payload: INITIAL.onMinimizar,
	};
}

/**
 * Callback consultado ao clicar no botão "home" da NavigationBar, ANTES de abrir
 * o alerta de minimizar. Retorne `false` para impedir a saída da tela — nesse
 * caso o alerta não abre e a própria tela é responsável por avisar o usuário do
 * motivo.
 *
 * Diferente de onMinimizar e onVoltarHome, este callback NÃO se auto-reseta após
 * a chamada: ele vale enquanto a tela estiver montada, para que a checagem se
 * repita a cada clique.
 * @param {() => boolean | void} callback
 */
function onTentarSair(callback) {
	return {
		type: TypesNavigationBar.ON_TENTAR_SAIR,
		payload: callback,
	};
}

/**
 * Reseta o cb da função onTentarSair
 */
function resetOnTentarSair() {
	return {
		type: TypesNavigationBar.ON_TENTAR_SAIR,
		payload: INITIAL.onTentarSair,
	};
}
